import { Button, Form, Input, Space, Tag } from "antd";
import React from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { createProduct } from "../../../../api/explore.api";
import { LogEvents, LoggerContext } from "../../../../context/logging";
import styles from "./AddProductForm.module.scss";

/**
 * Form for adding a product by the organisation.
 * Params to be sent:
 * 1. organisationId
 * 2. product_name
 * 3. product_description
 * 4. product_image
 * 5. brand
 * 6. product_price
 * @param {{ onClose: () => void }} props props passed to component
 * @returns {React.ReactNode}
 */

const AddProductForm = (props) => {
  const [form] = Form.useForm();
  const [productImages, setProductImages] = React.useState([]);
  const inputRef = React.useRef(null);
  const logger = React.useContext(LoggerContext);

  const onFinish = (values) => {
    logger.log(LogEvents.addProduct);
    const formData = new FormData();
    formData.append("organisation", props?.settings?.user?.organisation?.organisation_id);
    formData.append("product_name", values.product_name);
    formData.append("product_description", values.product_description);
    formData.append("brand", values.brand);
    formData.append("product_price", values.product_price);
    Array.from(productImages).forEach((image) => {
      formData.append("product_image", image);
    });

    createProduct(formData)
      .then((response) => {
        if (response) {
          props.onClose();
          toast.success("Product added successfully");
          logger.log(LogEvents.addProductSuccess);
        }
      });
  };

  return (
    <Form form={form} layout="vertical" className={styles.container} onFinish={onFinish}>
      <div className={styles.title}>
        Add Product
      </div>
      <Form.Item
        name="product_name"
        label="Product Name"
        rules={[
          {
            required: true,
            message: "Please enter product name",
          },
        ]}
      >
        <Input placeholder="Product Name" />
      </Form.Item>
      <Form.Item
        name="product_description"
        label="Product Description"
        rules={[
          {
            required: true,
            message: "Please enter product description",
          },
        ]}
      >
        <Input placeholder="Product Description" />
      </Form.Item>
      <Form.Item
        name="brand"
        label="Brand"
        rules={[
          {
            required: true,
            message: "Please enter brand",
          },
        ]}
      >
        <Input placeholder="Brand" />
      </Form.Item>
      <Form.Item
        name="product_price"
        label="Product Price"
        rules={[
          {
            required: true,
            message: "Please enter product price",
          },
        ]}
      >
        <Input placeholder="Product Price" type="number" />
      </Form.Item>
      <section className={styles.imageUploadContainer}>
        <input
          type="file"
          id="file"
          multiple
          onChange={(e) => {
            logger.log(LogEvents.addProductImages);
            setProductImages(e.target.files);
          }}
          ref={inputRef}
          style={{ width: 1, height: 1, opacity: 0, overflow: "hidden" }}
        />
        <Space align="center" wrap>
          <Button onClick={() => inputRef.current?.click()}>
            Add Product Images
          </Button>
          {productImages.length > 0 && (
            Array.from(productImages).map((file, index) => (
              <Tag
                key={index}
                closable
                onClose={(e) => {
                  e.preventDefault();
                  setProductImages(
                    productImages.filter((img, idx) => index !== idx)
                  );
                }}
              >
                {file?.name}
              </Tag>
            ))
          )}
        </Space>
      </section>
      <Form.Item>
        <Button style={{ width: '100%' }} type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
};

const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});

export default connect(mapStateToProps)(AddProductForm);
